import React from 'react';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { makeStyles } from '@material-ui/core';
import { getExportFilename } from '../utils/tableUtils';

const useStyles = makeStyles({
  root: {
    textDecoration: 'none'
  }
});

const ExportLink = ({ data, children }) => {
  const classes = useStyles();

  const getHeaders = () => {
    const columns = data.columns || [];
    return columns.map(column => ({
      key: column.key,
      label: column.title
    }));
  };

  const getData = () => {
    const headers = getHeaders();
    const rows = data.rows || [];

    if (!headers.length) {
      return rows.reduce((acc, next) => {
        acc.push(Object.values(next));
        return acc;
      }, []);
    }

    return rows.map(row =>
      headers.reduce((res, next) => ({ ...res, [next.key]: row[next.key] }), {})
    );
  };

  return (
    <CSVLink
      className={classes.root}
      filename={getExportFilename(data.title)}
      headers={getHeaders()}
      data={getData()}
    >
      {children}
    </CSVLink>
  );
};

ExportLink.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      columns: PropTypes.arrayOf().isRequired,
      rows: PropTypes.arrayOf().isRequired
    })
  ).isRequired,
  children: PropTypes.node.isRequired
};

export default ExportLink;
